import { apiClient } from "./client";
import {
  parseStorefrontProductsResponse,
  StorefrontProductsResponse,
} from "../config/storefront.schema";

export const fetchStorefrontProducts = async (
  identifier: string
): Promise<StorefrontProductsResponse> => {
  const { data } = await apiClient.get(
    `/storefronts/${encodeURIComponent(identifier)}/products`
  );
  return parseStorefrontProductsResponse(data);
};
